import * as types from '@/store/mutation-types'

const state = () => ({
  isSwiperInstalled: false
})

const getters = {
  isSwiperInstalled: state => state.isSwiperInstalled
}

const mutations = {
  [types.SET_SWIPER_AS_INSTALLED](state) {
    state.isSwiperInstalled = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
